import React from 'react'
import { ErrorBoundary, Footer } from '@sainsburys-tech/bolt'

class ArgosFooter extends React.PureComponent {
  render() {
    return (
      <ErrorBoundary>
        <section className='container--footer'>
          <Footer />
        </section>
      </ErrorBoundary>
    )
  }
}

export default ArgosFooter
